import { mandatoryFieldValditor, pinCodeValidator } from 'common/utils/validator';
import { formElement } from 'dedicated/components/summary/summary.constant';

export const addressSchema = {
  pinCode: { ...formElement, validator: pinCodeValidator },
  address: { ...formElement, validator: mandatoryFieldValditor },
  city: { ...formElement }
};

export const formSchema = {
  ...addressSchema,
  selected: false
};

export const getDefaultValue = (order) => {
  const shippingDetails = order?.shippingAddress;
  const isSelected = shippingDetails?.shippingAddressType === 'SAME_AS_BILLING' ? true : false;

  return {
    ...formSchema,
    selected: isSelected,
    address: {
      ...formSchema.address,
      value: shippingDetails?.addressLine1 || ''
    },
    city: {
      ...formSchema.city,
      value: shippingDetails?.city || ''
    },
    pinCode: {
      ...formSchema.pinCode,
      value: shippingDetails?.pincode || ''
    }
  };
};
